import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Palette, Target, ShieldCheck } from 'lucide-react';
const steps = [{
  id: 'CREAR',
  title: 'Tu empresa registrada y en orden.',
  icon: <FileText className="w-8 h-8 text-inkova-primary" data-id="element-341" />,
  desc: 'Te acompañamos en el proceso de registrar tu LLC, obtener tu EIN y presentar todo correctamente ante Sunbiz.',
  note: 'Inkova gestiona y coordina el proceso de registro de tu empresa. No somos un despacho de abogados.'
}, {
  id: 'CONSTRUIR',
  title: 'Estructura, modelo y dirección clara.',
  icon: <Palette className="w-8 h-8 text-inkova-primary" data-id="element-342" />,
  desc: 'Tu negocio necesita una base: saber cómo opera, cómo cobra, cómo se organiza y qué responsabilidades tiene.'
}, {
  id: 'POSICIONAR',
  title: 'Identidad + presencia digital.',
  icon: <Target className="w-8 h-8 text-inkova-primary" data-id="element-343" />,
  desc: 'Te ayudamos a construir tu identidad corporativa y tu presencia digital lista para atraer clientes.'
}, {
  id: 'SOSTENER',
  title: 'Cumplimiento anual + acompañamiento.',
  icon: <ShieldCheck className="w-8 h-8 text-inkova-primary" data-id="element-344" />,
  desc: 'Te acompañamos en el cumplimiento anual para que tu empresa siga operando sin interrupciones.'
}];
export function ProcessSection() {
  return <section id="proceso" className="py-20 bg-white relative overflow-hidden" data-id="element-345">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 mb-12" data-id="element-346">
        <div className="text-center max-w-3xl mx-auto" data-id="element-347">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif text-inkova-primary mb-4" data-id="element-348">
            En Inkova trabajamos en 4&nbsp;etapas&nbsp;naturales.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-xl font-light text-gray-600" data-id="element-349">
            Porque un negocio no se crea de golpe. Se
            construye&nbsp;con&nbsp;orden.
          </motion.p>
          <p className="text-sm text-gray-400 mt-4" data-id="element-350">
            Desliza para ver todas las etapas →
          </p>
        </div>
      </div>

      {/* Horizontal swipeable carousel */}
      <div className="relative" data-id="element-351">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-8 md:w-20 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-352"></div>
        <div className="absolute right-0 top-0 bottom-0 w-8 md:w-20 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-353"></div>

        <div className="flex gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory px-8 md:px-20 pb-4" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-354">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex-shrink-0 w-[280px] sm:w-[300px] md:w-[320px] snap-center" data-id="element-355">
              <div className="bg-inkova-light rounded-2xl p-6 border border-inkova-accent/20 shadow-sm h-full relative overflow-hidden" data-id="element-356">
                <div className="absolute top-0 right-0 bg-inkova-primary text-inkova-accent font-bold px-4 py-1 rounded-bl-xl text-xs uppercase tracking-widest" data-id="element-357">
                  ETAPA {i + 1}
                </div>

                <div className="w-14 h-14 rounded-xl bg-white flex items-center justify-center mb-4 shadow-sm border border-inkova-accent/30" data-id="element-358">
                  {step.icon}
                </div>

                <h3 className="text-lg font-serif font-bold text-inkova-primary mb-1" data-id="element-359">
                  {step.id}
                </h3>
                <h4 className="text-sm font-medium text-gray-800 mb-3" data-id="element-360">
                  {step.title}
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed font-light" data-id="element-361">
                  {step.desc}
                </p>

                {step.note && <p className="text-[11px] text-gray-400 italic mt-3 pt-3 border-t border-gray-200" data-id="element-362">
                    {step.note}
                  </p>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}